import * as types from './types';

const INITIAL_STATE = {
  servedItems: [],
  fetchError: '',
  fetching: false,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.SERVED_ITEM_SETUP_GET_DATA:
      const servedItems = [...payload.servedItems].map(item => {
        item['MealId'] = item.Id.substr(0, 1);
        return item;
      });
      return {
        ...state,
        servedItems: servedItems,
      };

    case types.SERVED_ITEM_SETUP_FETCH_ERROR:
      return { ...state, fetchError: payload };

    case types.SERVED_ITEM_SETUP_FETCHING:
      return { ...state, fetching: payload };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/serveditemsetup/state/serveditemsetup/reducer.js